import 'antd/dist/antd.less'
import 'Src/styles/scss/style.scss'
import 'Src/styles/less/style.less'
import 'react-virtualized/styles.css'
import 'react-day-picker/lib/style.css'
import 'moment/locale/ru'

import React, { lazy, FC } from 'react'
import { Switch, Route } from 'react-router-dom'
import { ConnectedRouter } from 'connected-react-router'
import { Notifs } from 'redux-notifications'
import { ThemeProvider } from 'styled-components'
import { addLocaleData } from 'react-intl'
import * as ru from 'react-intl/locale-data/ru'
import * as en from 'react-intl/locale-data/en'
import { ErrorBoundary } from 'HOCs'
import { store, history } from 'Store'
import { FrontUrls } from 'Src/constants/FrontUrls'
import Provider from 'Src/containers/Provider'
import { GlobalHistory } from 'Src/routes/history'
import { publicRoutes, publicPartnerProfileRoutes, publicRbidosPaymentRoutes } from 'Src/routes'
import {
	GlobalLoader,
	NotificationPopup,
	DeviceDetectComponent,
	NotifyComponent,
	SuspenseComponent,
	LazyRoute,
	userSettingSlice,
} from 'Modules'
import { themeObject, GlobalStyle } from 'LibNeo'
import { useUnmount } from 'Src/hooks/useUnmount'
import { auth } from 'Helpers'
import { useDeviceDetect } from 'Src/hooks/useDeviceDetect'
import { Page_404Component } from 'Components'
import { PrivateRoute } from './PrivateRoute'
import { NotificationComponent } from './Notifications'

const AuthRouterContainerLazy = lazy(() => import('Pages/auth/routes/AuthRouter'))
const AuthSbbolContainerLazy = lazy(() => import('./AuthSbbol'))
const ExternalAddOrderFormsConnectedLazy = lazy(
	() => import('Pages/orders/externalForms/components/ExternalOrderForms/index')
)
const BgDownloadFile = lazy(() => import('Pages/ibro/requests/components/DownloadFile'))
const AppContainerLazy = lazy(() => import('Pages/root/components/App'))

addLocaleData([...ru, ...en])

const RootContainer: FC = () => {
	useUnmount(() => {
		store.dispatch(userSettingSlice.actions.destroyStore())
	})

	const { isMobile } = useDeviceDetect()

	return (
		<ThemeProvider theme={themeObject}>
			<GlobalStyle />
			{/* @ts-ignore */}
			<Provider store={store}>
				<div>
					<ConnectedRouter history={history}>
						<DeviceDetectComponent />
						<GlobalHistory />
						<Switch>
							<LazyRoute
								path={`${FrontUrls.orders.externalForms}/:token`}
								lazyComponent={ExternalAddOrderFormsConnectedLazy}
							/>
							{publicRbidosPaymentRoutes}
							{publicPartnerProfileRoutes}
							{!auth.loggedIn() && publicRoutes}
							<LazyRoute path={FrontUrls.auth.sbbol} lazyComponent={AuthSbbolContainerLazy} />
							<LazyRoute path={FrontUrls.auth.index} lazyComponent={AuthRouterContainerLazy} />
							<PrivateRoute
								path={FrontUrls.broker.download_file}
								render={() => (
									<SuspenseComponent>
										<BgDownloadFile />
									</SuspenseComponent>
								)}
							/>
							<PrivateRoute
								path={FrontUrls.root}
								render={() => (
									<SuspenseComponent>
										<AppContainerLazy />
									</SuspenseComponent>
								)}
							/>
							<Route path="*" component={Page_404Component} />
						</Switch>
					</ConnectedRouter>
					<Notifs CustomComponent={NotificationComponent} store={store} />
					<GlobalLoader />
					{!isMobile && <NotificationPopup />}
					{!isMobile && <NotifyComponent />}
				</div>
			</Provider>
		</ThemeProvider>
	)
}

export default ErrorBoundary()(RootContainer)
